/**
 * Base delle chiamate API, in un punto solo.
 *
 * In produzione sito e API stanno sulla stessa origine (granborgo.com è servito
 * dallo stesso uvicorn che espone /api/v1): base vuota, richieste relative. In
 * sviluppo (`vite dev`) le API sono su localhost:8000.
 *
 * Prima ogni file aveva `?? "http://localhost:8000"`: un build fatto senza il
 * `.env.production` personale cuoceva localhost nel bundle e il sito si apriva
 * senza dati (R-11). Ora il ripiego dipende dalla modalità del build, e
 * `npm run build:verify` controlla che nel bundle non resti localhost.
 */
export const API_BASE: string =
  import.meta.env.VITE_API_BASE_URL ?? (import.meta.env.DEV ? "http://localhost:8000" : "");
